import React, { Component } from "react";
import ajax from "../../ajax";
import functions from "../../functions";
import DashCard from "../Common/DashCard";

export default class TotalSalesToday extends Component {
  state = {
    shop_id: functions.sessionGuard(),
    total: false,
  };

  async componentDidMount() {
    await this.getTotalSalesToday();
    this.timerActual = setTimeout(
      (this.func1 = async () => {
        await this.getTotalSalesToday();
        this.timerActual = setTimeout(this.func1, 2000); // (*)
      }),
      2000
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timerActual);
  }

  getTotalSalesToday = async () => {
    const server_response = await ajax.totalSalesToday(this.state.shop_id);
    if (server_response.status == "OK") {
      this.setState({
        total: server_response.details,
        message: server_response.message,
      });
    } else {
      this.setState({
        message: server_response.message,
      });
    }
  };
  render() {
    const { total } = this.state;
    const final = total.total ? total.total : "0";
    return (
      <DashCard
        title="Total sales Today"
        value={"Ugx. " + final}
        icon={"fas fa-chart-bar"}
      />
    );
  }
}
